export const DISCOUNT_TYPES = ["student"] as const;
